import { jsx as _jsx } from "react/jsx-runtime";
import cn from "classnames";
const ChevronSm = ({ className }) => {
    return (_jsx("svg", { className: cn(className), width: "11", height: "11", viewBox: "0 0 12 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M11 1L6 7L1 1", stroke: "#0062B8", strokeWidth: "1.5" }) }));
};
export default ChevronSm;
